import { useQuery } from "@tanstack/react-query";

import { similarPartFeedbacksQuery } from "#modules/feedback/infra/similarPartFeedbacks.query";

export const useSimilarPartFeedbacks = (sourcePartId: string | undefined) => {
  const { data, ...rest } = useQuery({ ...similarPartFeedbacksQuery(sourcePartId) });

  return { similarPartFeedbacks: data, ...rest };
};
